module.exports = "data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAABwAwCdASoZABkAPpFCnEolo6KhqAgAsBIJZQC7ABbY098LgAAA/uveLrjc3XiXRmR1KG2sOVDUIUwCcif3d2OF1RgqFexLAAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/olive.webp
// module id = NLyJ
// module chunks = 14